/**
 * OS Settings API Service
 *
 * Handles persistence of per-user aniOS preferences (pinned/hidden dock apps).
 */

import { apiRequest } from "../client";
import type { OsSettingsRequest, OsSettingsResponse } from "./types";

const BASE_URL = "/os-settings";

export async function getOsSettings(): Promise<OsSettingsResponse | null> {
  try {
    return await apiRequest<OsSettingsResponse>({ method: "GET", url: BASE_URL });
  } catch (error: unknown) {
    const axiosError = error as { response?: { status?: number } };
    if (axiosError.response?.status === 404) {
      return null;
    }
    throw error;
  }
}

export async function saveOsSettings(
  settings: OsSettingsRequest,
): Promise<OsSettingsResponse> {
  return apiRequest<OsSettingsResponse>({
    method: "PUT",
    url: BASE_URL,
    data: settings,
  });
}

export type { OsSettingsRequest, OsSettingsResponse } from "./types";
